(() => {
  angular
    .module('gm.common.services')
    .factory('GmyNotifications', GmyNotifications);

  function GmyNotifications(
    $q,
    $filter,
    gmSocketFactory,
    GmyVaults,
    GmyTransactions,
    $rootScope
  ) {
    'ngInject';

    const NOTIFICATION_TYPES = {
      TRADE: 'Trade',
      TRADE_CONFIRMED: 'Trade-Confirmed',
      USER_STATE: 'UserState'
    };

    const _notifications = {
      counter: 0,
      events: []
    };

    let _notificationListeners = [];
    let _socket;

    return {
      NOTIFICATION_TYPES,

      addEvent,
      connect,
      disconnect,
      dismissAllEvents,
      getEvents,
      notifyLocal,
      onNotification,
      offNotification,
      removeAllEvents,
      removeEvent,
    };

    function addEvent(notificationeEvent) {
      _notifications.events.push(notificationeEvent);
      _notifications.counter = _notifications.events.length;
    }

    function connect() {
      const deferred = $q.defer();

      if (!_socket) {
        _socket = gmSocketFactory.create('/ws/notifications');

        _socket.on('message', (data) => {
          let transaction;
          let hasEvent = false;

          GmyVaults.getVaults()
          .then((vaults) => {
            if (data.type === NOTIFICATION_TYPES.TRADE
              || data.type === NOTIFICATION_TYPES.TRADE_CONFIRMED) {
              transaction = processNotificationTrade(data.trade, vaults);

              if (data.type === NOTIFICATION_TYPES.TRADE) {
                hasEvent = processNotificationEvent(
                  prepareNotificationEvent(transaction, data.type)
                );
              }
            }

            if (!hasEvent) {
              notifyListeners(data.type, data);
            }
          });
        });

        GmyVaults.getVaults()
          .then(() => {
            _socket.connect();
            deferred.resolve(_socket);
          })
          .catch((error) => {
            deferred.reject(error);
          });
      } else {
        deferred.resolve(_socket);
      }

      return deferred.promise;
    }

    function disconnect() {
      if (_socket) {
        _socket.disconnect();
      }
      _socket = null;
    }

    function dismissAllEvents() {
      _notifications.events.forEach((item) => {
        if (angular.isFunction(item.close)) {
          item.close();
        }
      });

      removeAllEvents();
      sendDismissAllNotificationsCommand();
    }

    function getEvents() {
      return _notifications.events;
    }

    function notifyListeners(type, data) {
      $rootScope.$broadcast(`notification:${type}`, data);

      _notificationListeners.forEach((n) => {
        if (!n.types || n.types.indexOf(type) > -1) {
          n.cb(data);
        }
      });
    }

    function notifyLocal(data) {
      _notificationListeners.forEach(n => n.cb(data));
    }

    function onNotification(callback, types = null) {
      _notificationListeners.push({ cb: callback, types });
    }

    function offNotification(callback) {
      _notificationListeners = _notificationListeners.filter(n => n.cb !== callback);
    }

    /**
     * Process notification's trade, add/update user's transaction and return this transaction
     * @param {Object} trade
     * @returns {Object}
     */
    function processNotificationTrade(trade, vaults) {
      const transaction = GmyTransactions.processTransaction(trade, vaults);

      GmyTransactions.addTransaction(transaction);

      return transaction;
    }

    /**
     * Prepare notification event
     * @param transaction
     * @param {'Trade'|'Trade-Confirmed'}type
     * @returns {{time: Date, title: string, description: *, trade: *}}
     */
    function prepareNotificationEvent(transaction, type) {
      let title = `
        ${$filter('gmyFormatCurrency')(transaction.amount, 'GAU')} (${transaction.vault.name})
      `;
      const description = transaction.description;

      if (type === NOTIFICATION_TYPES.TRADE_CONFIRMED) {
        title = `Confirmed ${title}`;
      }

      return {
        id: type + transaction.id,
        time: new Date(transaction.ts),
        title,
        description,
        trade: transaction
      };
    }

    /**
     * Process new notification event, check presence of this event in list
     * @param notificationEvent
     */
    function processNotificationEvent(notificationEvent) {
      for (let i = 0, len = _notifications.events.length; i < len; i += 1) {
        if (_notifications.events[i].id === notificationEvent.id) {
          return true; // already have this event
        }
      }

      // new notification event
      addEvent(notificationEvent);

      return false;
    }

    function removeAllEvents() {
      _notifications.events.splice(0, _notifications.events.length);
    }

    function removeEvent(item) {
      const index = _notifications.events.indexOf(item);

      if (index > -1) {
        _notifications.events.splice(index, 1);
      }
    }

    function sendDismissAllNotificationsCommand() {
      _socket.send({ command: 'dismiss' });
    }
  }
})();
